import { render, staticRenderFns } from "./WebSetting.vue?vue&type=template&id=2efc5e9c&scoped=true"
import script from "./WebSetting.vue?vue&type=script&lang=js"
export * from "./WebSetting.vue?vue&type=script&lang=js"
import style0 from "./WebSetting.vue?vue&type=style&index=0&id=2efc5e9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efc5e9c",
  null
  
)

export default component.exports